import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/shift-patterns')({
  staticData: {
    permissionSection: 'settings',
    section: 'Settings',
    // Resolver (not a static string) so the crumb link keeps the selected
    // factory: TanStack Router's <Link> drops search params unless a `search`
    // prop is passed. Without this, clicking "Shift Patterns" from the editor
    // would land on the list with no `?factory=` and fall back to the first
    // factory instead of the one the user was viewing.
    breadcrumb: (match) => {
      const factory = (match.search as { factory?: string }).factory;
      return [
        {
          label: 'Shift Patterns',
          path: '/shift-patterns',
          ...(factory ? { search: { factory } } : {}),
        },
      ];
    },
  },
  component: () => <Outlet />,
});
